const $ = jQuery;

export const $window = $( window );
